<template>
    <div>
        <!-- 轮播图 -->
        <div class="header">
            <div class="header-tag">Milestone</div>
            <div class="header-title">发展历程</div>
        </div>
        <div style="margin: 30px 0;">
            <ul class="news-container">
                <li v-for="(item,index) in milestoneList" :key="index" >
                    <div class="content">
                        <!-- <p>{{item.title}}</p> -->
                        <p v-html="item.title"></p>
                    </div>
                    <div class="time" >
                        <span style="background-color: #0AA00A;">&nbsp;&nbsp;{{item.occuDate}}&nbsp;&nbsp;</span>
                    </div>
                    <div class="circle">
                        <img src="../../assets/img/circle.png">
                         <i class="line center-block"></i> 
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
  
<script type="text/babel">
export default {
  name: "HomePage",
  data() {
    return {
      
        milestoneList:[
                
            ]
    };
  },
  methods:{
   
  },
    mounted() {
            debugger
            let that=this;
            this.http.post("/api/FJ_Milestone/GetAllMilestone",JSON.stringify({})).then((result)=>{
                debugger
            let objResult= eval(result);
            let iCode= objResult.code;
            if(iCode==0){
                debugger
                that.milestoneList=objResult.data;
                }
            });
        }
};
</script>
  
<style scoped lang="scss">
.header {
    background: url('../../assets/img/milestonebanner.jpg') no-repeat;
    background-size: 100%;
}
.news-container{
    overflow: hidden;
    margin-bottom: 0;
    list-style: none;
}
.news-container>li{
    width: 55.5%;
    height: 120px;
    float: left;
    color: #333;
    text-align: right;
    border-left: 1px solid transparent;
    border-right: 1px solid transparent;
}
.news-container>li:hover{
    color: #0a7846;
   font-weight: bold;
    border: 1px solid #ffffff;
    cursor: pointer;
}


.news-container>li:nth-of-type(2n){
    float: right;
    text-align: left;
}
.news-container>li>.content{
    width: 65%;
    float: left;
    padding: 10px 0;
    line-height: 30px;
}
.news-container>li>.time{
    width: 15%;
    float: left;
    align-items: center;  /* 垂直居中 */
    padding: 15px 0;
    color: #fff;
}

.news-container>li>.circle{
    width: 20%;
    height: 100%;
    float: left;
    position: relative;
}
.news-container>li>.circle>img{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 20px;
    height: 20px;
    // background-color:#0a7846;
}
.news-container>li>.circle>i{
    display: block;
    width: 1px;
    height: 100%;
    background: #707070;
}
.news-container>li:nth-of-type(2n)>.content{
    float: right;
}
.news-container>li:nth-of-type(2n)>.time{
    float: right;
}
.news-container>li:nth-of-type(2n)>.circle{
    float: right;
}
.news-container>li>.circle>i{
    height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
}
.more{
    font-size: 25px;
    color: #707070;
}
.more>i{
    cursor: pointer;
}
@media screen and (max-width: 767px){
    .news-container>li{
        width: 100%;
    }
    .news-container>li>.content{
        width: 70%;
        text-align: left;
        float: right;
    }
    .news-container>li>.time{
        width: 30%;
        text-align: left;
        float: right;
    }
    .news-container>li>.circle{
        display: none;
    }
}
</style>
  


// WEBPACK FOOTER //
// src/views/milestone/index.vue